import { faHistory } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon';

export const HistoryIcon = (props: { color?: string }) => {
  return (
    <FontAwesomeIcon icon={faHistory} color={props.color || 'black'} />
  )
}
